export default class mailEditor {
    constructor() {
        return {
            restrict: 'E',
            scope: {},
            controller: EditorCtrl,
            controllerAs: 'editor'
        }
    }
}

class EditorCtrl {
    constructor($scope, $compile) {
        this._compiler = $compile;
        this._scope = $scope;

        this.maxTextLength = 200;
        
        this._scope.$on('browser:editor:getContentTables', () => {
            this.getContentTables();
        });
        
        this._scope.$on('browser:editor:applyParagraphLengthSetting', (event, showLess) => {
            showLess ? this.less() : this.more();
        });

        this._scope.$on('browser:editor:applyImageSettings', (event, show) => {
            show ? $(this.images).show() : $(this.images).hide();
        });

        this.getImages();
        this.getElements();
        this.getTables();

        this._scope.$on('browser:editor:applyFontSize', (event, newSize) => {
            angular.forEach(this.elements, (element) => {
                let style = $(element).attr('style');
                let start = style.indexOf('font-size');

                if (start > -1) {
                    let end = style.indexOf(';', start) != -1 ? style.indexOf(';', start) : style.length;
                    $(element).attr('style', style.substring(0, start) + "font-size:" + newSize + '%' + style.substring(end, style.length))
                }
            });
        });

        this._scope.$on('browser:editor:applyLineHeight', (event, lineHeight) => {
            angular.forEach(this.elements, (element) => {
                let style = $(element).attr('style');
                let start = style.indexOf('line-height');

                if (start > -1) {
                    let end = style.indexOf(';', start) != -1 ? style.indexOf(';', start) : style.length;
                    $(element).attr('style', style.substring(0, start) + "line-height:" + lineHeight + 'em' + style.substring(end, style.length))
                }
            })
        });

        this._scope.$on('browser:editor:applyFont', (event, font) => {
            if (font) {
                angular.forEach(this.elements, (element) => {
                    let style = $(element).attr('style');
                    let start = style.indexOf('font-family');

                    if (start > -1) {
                        let end = style.indexOf(';', start) != -1 ? style.indexOf(';', start) : style.length;
                        $(element).attr('style', style.substring(0, start) + 'font-family:' + font.value + style.substring(end, style.length))
                    }
                });
            }
        });

        this._scope.$on('browser:editor:applyFontColor', (event, color) => {
            if (color) {
                angular.forEach(this.elements, (element) => {
                    let style = $(element).attr('style');
                    let start = style.indexOf('color');

                    if (start > -1) {
                        let end = style.indexOf(';', start) != -1 ? style.indexOf(';', start) : style.length;
                        $(element).attr('style', style.substring(0, start) + 'color:' + color + style.substring(end, style.length))
                    }
                });
            }
        });

        this._scope.$on('browser:editor:applyBackground', (event, color) => {
            if (color) {
                angular.forEach(this.contentTables, (table) => {
                    if ($(table).is("[bgcolor]")) {
                        $(table).attr('bgcolor', color)
                    }
                });

                angular.forEach(this.elements, (element) => {
                    let style = $(element).attr('style');
                    let start = style.indexOf('background-color') != -1 ? style.indexOf('background-color') : style.indexOf('background');

                    if (start > -1) {
                        let end = style.indexOf(';', start) != -1 ? style.indexOf(';', start) : style.length;
                        $(element).attr('style', style.substring(0, start) + 'background:' + color + style.substring(end, style.length))
                    }
                })
            }
        });
    }

    getContentTables() {
        this.contentTables = [];
        var i = $('.responsive').length > 0 ? 0 : 1;

        angular.forEach(this.tables, (table, index) => {
            if ($(table).attr('width') != null && index >= i) {
                this.contentTables.push(table);
            }
        });

        this._scope.$emit('browser:editor:tablesFetched', this.contentTables);
    };

    htmlDecodeWithLineBreaks(html) {
        let breakToken = '_______break_______',
            lineBreakedHtml = html.replace(/<br\s?\/?>/gi, breakToken).replace(/<p\.*?>(.*?)<\/p>/gi, breakToken + '$1' + breakToken);

        return $('<div>').html(lineBreakedHtml).text().replace(new RegExp(breakToken, 'g'), 'NEWLINE');
    };

    less(cutAt) {
        let lastChar;

        angular.forEach(this.elements, (element, index) => {
            // Check whether the div has an attribute font-family
            if ($(element).attr('style').indexOf('font-family') > -1) {
                let text = $.trim($(element).text());

                if (text.length > cutAt) {
                    this.originalParagraphHtml[index] = $(element).html();
                    text = this.htmlDecodeWithLineBreaks($(element).html());

                    for (cutAt; cutAt < text.length; cutAt++) {
                        lastChar = text.charAt(cutAt);

                        // Some margin to make it worthwhile to cut the paragraph short
                        if ((lastChar === '.' || lastChar === '!') && cutAt + 50 < text.length) {
                            var newText = text.substring(0, cutAt + 1);
                            $(element).text($.trim(newText)); // include the punctuation/exclamation
                            $(element).html($(element).html().replace(/NEWLINE/g, "<br>"));
                            $(element).append("<br><a href='' ng-click='editor.expandParagraph(" + index + ")' style='cursor:pointer'><strong>Visa hela stycket</strong></a>")
                            angular.element(this._compiler(element)(this._scope));
                            break;
                        }
                    }
                }
            }
        })
    };

    more() {
        angular.forEach(this.elements, (element, i) => {
            if ($(element).attr('style').indexOf('font-family') > -1) {
                $(element).html(this.originalParagraphHtml[i]);
                this._compiler(element)(this._scope);
            }
        })
    };

    expandParagraph(index) {
        $(this.elements[index]).html(this.originalParagraphHtml[index])
    };

    getTables(update) {
        if (! this.tables || update == true) {
            this.tables = $('.responsive').length > 0 ? $('.responsive') : $('table');
        }

        return this.tables;
    };

    getElements(update) {
        if (! this.elements || update == true) {
            if (! this.tables) {
                this.getTables(update)
            }

            this.elements = this.tables.find($("[style]"));
        }

        return this.elements;
    };

    getImages(update) {
        if (! this.images || update == true) {
            this.images = $("img");

            angular.forEach(this.images, (image) => {
                let grandParent = $(image).parent().parent();

                if (grandParent.hasClass("img")) {
                    this.images.push(grandParent[0]);
                }
            });
        }

        return this.images;
    };
}

/*angular.module('InBrowserApp').directive('mailEditor', function($rootScope, $compile) {

    var g_scope
    var tables, elements, images, start, end, style

    return {
        restrict: 'E',

        link: function($scope, element, attrs) {

            g_scope = $scope



            // Shortens long paragraphs. Should cut the paragraph at the end of a sentence. 
            $scope.less = function(cutAt) {
                var lastChar;
                angular.forEach(elements, function (element, index) {
                    // Check whether the div has an attribute font-family
                    if ($(element).attr('style').indexOf('font-family') > -1) {
                        var text = $.trim($(element).text())
                        if (text.length > cutAt) {
                            $scope.originalParagraphHtml[index] = $(element).html()
                            text = htmlDecodeWithLineBreaks($(element).html())

                            for (cutAt; cutAt < text.length; cutAt++) {
                                lastChar = text.charAt(cutAt)

                                // Some margin to make it worthwhile to cut the paragraph short
                               if ((lastChar === '.' || lastChar === '!') && cutAt + 50 < text.length) {
                                    var newText = text.substring(0, cutAt + 1)
                                    $(element).text($.trim(newText)) // include the punctuation/exclamation
                                    $(element).html($(element).html().replace(/NEWLINE/g, "<br>"))
                                    $(element).append("<br><a href='' ng-click='expandParagraph(" + index + ")' style='cursor:pointer'><strong>Visa hela stycket</strong></a>")
                                    angular.element($compile(element)(g_scope))
                                    break
                                }
                            }
                        }
                    }
                })
            };

            $scope.more = function() {
                angular.forEach(elements, function(element, i) {
                    if ($(element).attr('style').indexOf('font-family') > -1) {
                        $(element).html($scope.originalParagraphHtml[i]);
                        $compile(element)($scope);
                    }
                })
            };

            $scope.$watch('settings.show_images', function(newVal, oldVal) {
                newVal ? $(images).show() : $(images).hide();
            });

            $scope.expandParagraph = function(index) {
                $(elements[index]).html($scope.originalParagraphHtml[index])
            };

            $scope.getTables = function(update) {
                if(!tables || update == true) {
                    tables = $('.responsive')
                    if(tables.length == 0) {
                        tables = $('table')
                    }
                }
                return tables
            };

            $scope.getElements = function(update) {
                if(!elements || update == true) {
                    if(!tables) {
                        $scope.getTables(update)
                    }
                    elements = tables.find($("[style]"))
                }
                return elements
            };

            $scope.getImages = function(update) {
                if (!images || update == true) {
                    images = $("img")
                    angular.forEach(images, function(image) {
                        var grandParent = $(image).parent().parent()
                        if (grandParent.hasClass("img")) {
                            images.push(grandParent[0]);
                        }
                    })
                }
                return images
            };

            $scope.getImages();
            $scope.getElements();
            $scope.getTables();

            // Apply changes to view
           $scope.applyFontSize = function(newVal) {
                angular.forEach(elements, function(element) {
                    style = $(element).attr('style');
                    start = style.indexOf('font-size');
                    if (start > -1) {
                        end = style.indexOf(';', start);
                        if (end == -1) {
                            end = style.length
                        }
                        $(element).attr('style', style.substring(0, start) + "font-size:" + newVal + '%' + style.substring(end, style.length))
                    }
                })
            };

            $scope.applyLineHeight = function(newVal) {
                angular.forEach(elements, function(element) {
                    style = $(element).attr('style');
                    start = style.indexOf('line-height');
                    if (start > -1) {
                        end = style.indexOf(';', start);
                        if (end == -1) {
                            end = style.length
                        }
                        $(element).attr('style', style.substring(0, start) + "line-height:" + newVal + 'em' + style.substring(end, style.length))
                    }
                })
            };

            $scope.$watch('settings.font_family', function(font) {
                if (font) {
                    angular.forEach(elements, function(element) {
                        style = $(element).attr('style')
                        start = style.indexOf('font-family')
                        if (start > -1) {
                            end = style.indexOf(';', start)
                            if (end == -1) {
                                end = style.length
                            }
                            $(element).attr('style', style.substring(0, start) + 'font-family:' + font + style.substring(end, style.length))
                        }
                    })
                }
            });

            $scope.$watch('settings.font_color', function(color) {
                if ((! $scope.settingsLoaded && color == "#000000") || ! color) {
                    return;
                }
                angular.forEach(elements, function(element) {
                    style = $(element).attr('style');
                    start = style.indexOf('color');

                    if (start > -1) {
                        end = style.indexOf(';', start);

                        if (end == -1) {
                            end = style.length;
                        }

                        $(element).attr('style', style.substring(0, start) + 'color:' + color + style.substring(end, style.length))
                    }
                })
            });

            $scope.$watch('settings.background_color', function(color) {

                if ((! $scope.settingsLoaded && color == "#ffffff") || ! color) {
                    return;
                }

                angular.forEach($scope.contentTables, function(table) {
                    if ($(table).is("[bgcolor]")) {
                        $(table).attr('bgcolor', color)
                    }
                });

                angular.forEach(elements, function(element) {
                    style = $(element).attr('style');
                    start = style.indexOf('background-color');

                    if (start == -1) {
                       start = style.indexOf('background')
                    }

                    if (start > -1) {
                        end = style.indexOf(';', start);

                        if (end == -1) {
                            end = style.length
                        }

                        $(element).attr('style', style.substring(0, start) + 'background:' + color + style.substring(end, style.length))
                    }
                })
            });

            // Finds the outmost table with width attribute specified and attaches the resizer
        }
    }
});*/
